module.exports = __webpack_public_path__ + "r-v3/img/speaker_on.9ba9c130.svg";